import { render, staticRenderFns } from "./FeedInventoryPage.vue?vue&type=template&id=322c9390&scoped=true&"
import script from "./FeedInventoryPage.vue?vue&type=script&lang=js&"
export * from "./FeedInventoryPage.vue?vue&type=script&lang=js&"
import style0 from "./FeedInventoryPage.vue?vue&type=style&index=0&id=322c9390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322c9390",
  null
  
)

export default component.exports